"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconUser = void 0;
class FalconUser {
}
exports.FalconUser = FalconUser;
//# sourceMappingURL=FalconUser.js.map